
/* sc-hotfix.js: add a stable class to the Dealer CTA so CSS can style it consistently */
(function(){
  function tagCTA(){
    var anchors = document.querySelectorAll('a[href*="/become-a-dealer"], a[href*="become-a-dealer"], a[href$="/pages/become-a-dealer"]');
    anchors.forEach(function(a){ a.classList.add('dealer-cta'); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tagCTA);
  } else { tagCTA(); }
})();
